<!-- Decorative: the contact's name is always printed next to it. -->
<span [class]="merge('contactAvatar', class)" aria-hidden="true">
  @if (avatarUrl) {
    <img [src]="avatarUrl" alt="" class="contactAvatar__img" />
  } @else if (Inititals) {
    <span [class]="merge('contactAvatar__initials', InitialClass)">{{ Inititals }}</span>
  } @else {
    <span class="bk-sym contactAvatar__icon">person</span>
  }
</span>
